import { Box, Icon } from "@chakra-ui/react";
import { HiOutlineMenuAlt3 as MenuIcon } from "react-icons/hi";
import { MdOutlineClose as CloseIcon } from "react-icons/md";

const MenuToggle = ({ isOpen, toggle }) => {
  return (
    <Box
      cursor="pointer"
      display={{ base: "block", md: "none" }}
      onClick={toggle}
    >
      {isOpen ? <Icon as={CloseIcon} /> : <Icon as={MenuIcon} />}
    </Box>
  );
};

export default MenuToggle;
